import { useGsapFadeIn, useGsapStagger } from "@/hooks/useGsapAnimation";
import { ArrowUpRight } from "lucide-react";
import { b2bCompanies } from "@/constants";

const B2bSection = () => {
  const headingRef = useGsapFadeIn<HTMLDivElement>();
  const servicesRef = useGsapStagger<HTMLDivElement>();

  return (
    <section
      id="b2b"
      className="overflow-hidden relative px-2 lg:px-0 pt-40 pb-8 md:pt-16 md:pb-16 max-w-[1370px] mx-auto bg-[#f5f5f5]"
    >
      <div className="relative z-10">
        {/* Header */}
        <div ref={headingRef} className="px-6 lg:px-0 max-w-3xl mb-8 md:mb-16">
          <h3 className="font-[600] text-3xl sm:text-4xl md:text-6xl lg:text-6xl mb-6 font-orbitron leading-tight">
            <span className="text-foreground">Our</span>
            <br />
            <span className="text-primary">B2B Clients</span>
          </h3>
          <p className="text-left md:text-left text-md md:text-xl mb-8 max-w-2xl leading-relaxed font-poppins text-md text-muted-foreground">
            Companies that rely on our creative thinking and digital strategies
            to transform ideas into measurable results.
          </p>
        </div>

        {/* Services Grid */}
        <div ref={servicesRef} className="grid md:grid-cols-2 gap-4 md:gap-6">
          {b2bCompanies.map((company, index) => (
            <div
              key={company.title}
              className="p-6 md:p-8 rounded-[40px] bg-transparent border border-border group cursor-pointer transition-all duration-500 hover:bg-primary/5 hover:border-primary/20 hover:shadow-lg hover:shadow-primary/10 "
            >
              <div className="flex items-start justify-between mb-4">
                <div className="w-[50%] h-[72px] bg-transparent flex items-center justify-start">
                  <img
                    src={company.icon}
                    alt={company.title}
                    className="grayscale contrast-200 brightness-0 w-auto h-full object-contain bg-transparent  rounded-[20px] p-2"
                  />
                </div>
                <span className="text-5xl font-bold text-muted-foreground/20 group-hover:text-primary/50 transition-colors duration-500">
                  {String(index + 1).padStart(2, "0")}
                </span>
              </div>

              <h2 className="text-lg font-bold mb-2 text-[#0d1821]">
                {company.title}
              </h2>

              <p className="text-sm text-[#0d1821] mb-4 font-poppins text-justify">
                {company.description}
              </p>

              <div className="flex flex-wrap gap-2 mb-6">
                {company.tags.map((tag) => (
                  <span
                    key={tag}
                    className="px-3 py-1 text-xs font-medium font-poppins border border-[#c3f620] group-hover:bg-[#c3f620] group-hover:text-[#0d1821] rounded-full transition-all duration-500"
                  >
                    {tag}
                  </span>
                ))}
              </div>

              <div className="flex items-center gap-2 text-sm font-semibold text-primary opacity-80 group-hover:opacity-100 transition-opacity">
                <ArrowUpRight className="w-4 h-4" />
                {company.location}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default B2bSection;
